module.exports = __webpack_public_path__ + "static/media/img131_R.9f14649c.jpg";